import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchOrderHubOrders } from '@/api/order-hub';
import type { OrdersHubListParams } from '../-utils/listParams';
import {
  buildOrdersHubQs,
  normalizeOrdersHubListParams,
} from '../-utils/listParams';

export const ordersHubKeys = {
  all: ['orders-hub'] as const,
  list: (params: OrdersHubListParams) =>
    [...ordersHubKeys.all, 'list', params] as const,
  lines: (orderId: string) => [...ordersHubKeys.all, 'lines', orderId] as const,
  detail: (id: string) => [...ordersHubKeys.all, 'detail', id] as const,
  attachments: (orderId: string, params: { page: number; count: number }) =>
    [...ordersHubKeys.all, 'attachments', orderId, params] as const,
  /** Under `all`, so every send, edit, archive and import refreshes it. */
  readinessAll: ['orders-hub', 'readiness'] as const,
  readiness: (orderIds: string[], includeLines: boolean) =>
    ['orders-hub', 'readiness', includeLines, orderIds] as const,
};

export function ordersHubQueryOptions(params: OrdersHubListParams) {
  const normalized = normalizeOrdersHubListParams(params);
  return queryOptions({
    queryKey: ordersHubKeys.list(normalized),
    queryFn: () => fetchOrderHubOrders(buildOrdersHubQs(normalized)),
    staleTime: 30_000,
  });
}

export function useOrdersHubList(params: OrdersHubListParams) {
  return useQuery(ordersHubQueryOptions(params));
}
